import HttpClient from "../../../../core/HttpClient";
import { Authentication } from "@leedpulse-monorepo/classes";

/**
 * Streams the call recording straight from Storage (via the same endpoint the
 * Callr calls page uses) and returns a local blob URL to play it. Unlike the
 * signed URL stored on `Calls.url_recording` (30min TTL, stamped once at
 * transcription time), this never expires — the file is re-read on every call.
 *
 * `GET /calls/:id/recording` (shared with the GSM/Callr calls page) resolves
 * `:id` as a Firestore DOCUMENT id, not a LiveKit room name — pass the row's
 * `id` (== `doc.id`), never `roomName` (LEED-1135 decoupled the two).
 */
async function getVoipCallRecording(
    auth: Authentication | null,
    docId: string,
): Promise<string | null> {
    if (!auth || !docId) return null;

    // Volontairement sans `catch` : le backend distingue « aucun
    // enregistrement sur cet appel » (404, le cas de loin le plus fréquent)
    // d'une vraie panne, et son message est celui à afficher. Avalé ici,
    // l'appelant n'avait plus qu'un « impossible de charger » identique dans
    // les deux cas.
    const blob = await HttpClient.getBlob(`/calls/${encodeURIComponent(docId)}/recording`, auth.token);
    return URL.createObjectURL(blob);
}

export default getVoipCallRecording;
